exports = module.exports = require('./lib/textarea-auto-height.js');
